import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import AddToCart from "../Cart/AddToCart";
import AddAvis from "../Avis/AddAvis";
import Avis from "../Avis/Avis";
import { motion } from "framer-motion";
import { toast } from "react-toastify";
import { FaTruck, FaUndo, FaHeart, FaRegHeart, FaTag, FaGift } from "react-icons/fa";
import api from "../../utils/axiosConfig";
import Footer from "../Footer";
import ThreeModelViewer from "../ThreeModelViewer";
import ReactMarkdown from "react-markdown";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

const styles = {
  container: {
    fontFamily: "'Cormorant Garamond', serif",
    maxWidth: "1200px",
    margin: "auto",
    padding: "2rem",
    background: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "20px",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
    position: "relative",
    overflow: "hidden",
  },
  containerBefore: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)",
    borderRadius: "20px",
    zIndex: -1,
  },
  productGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: "2rem",
    marginBottom: "2rem",
    position: "relative",
    zIndex: 2,
  },
  imageSection: {
    flex: 1,
    padding: "1.5rem",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(15px)",
    borderRadius: "15px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.08)",
    display: "flex",
    flexDirection: "column",
    height: "fit-content",
  },
  detailsSection: {
    flex: 1,
    minWidth: "100%", // Sera modifié dynamiquement
    padding: "2rem",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(15px)",
    borderRadius: "15px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.08)",
    position: "relative",
    overflow: "hidden",
  },
  detailsSectionBefore: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)",
    borderRadius: "15px",
    zIndex: -1,
  },
  mainImage: {
    width: "100%",
    height: "500px",
    objectFit: "cover",
    borderRadius: "12px",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    backdropFilter: "blur(10px)",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
  },
  thumbnailContainer: {
    display: "flex",
    gap: "10px",
    marginTop: "10px",
    flexWrap: "wrap",
  },
  thumbnail: {
    width: "80px",
    height: "80px",
    objectFit: "cover",
    borderRadius: "8px",
    cursor: "pointer",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    backdropFilter: "blur(5px)",
    transition: "all 0.3s ease",
  },
  thumbnailSelected: {
    border: "2px solid #d4af37",
    boxShadow: "0 4px 12px rgba(212, 175, 55, 0.3)",
    transform: "scale(1.05)",
  },
  productHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
  productTitle: {
    fontSize: "22px",
    marginBottom: "10px",
    color: "#2c1810",
    fontFamily: "'Cormorant Garamond', serif",
    fontWeight: "600",
  },
  favoriteButton: {
    background: "rgba(255, 255, 255, 0.1)",
    border: "1px solid rgba(212, 175, 55, 0.3)",
    cursor: "pointer",
    color: "#d4af37",
    fontSize: "1.8rem",
    padding: "10px",
    borderRadius: "50%",
    backdropFilter: "blur(10px)",
    transition: "all 0.3s ease",
  },
  priceContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "0.25rem",
    marginBottom: "15px",
  },
  originalPrice: {
    fontSize: "1.3rem",
    color: "#64748b",
    fontWeight: "700",

    textDecoration: "line-through",
    position: "relative",
  },
  normalPrice: {
    fontWeight: "700",
    fontSize: "1.3rem",
    color: "#d4af37",
  },
  promoPriceContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  promoPrice: {
    fontWeight: "700",
    fontSize: "1.3rem",
    color: "#d4af37",
  },
  promoBadge: {
    backgroundColor: "#ef4444",
    color: "white",
    padding: "0.25rem 0.5rem",
    borderRadius: "20px",
    fontSize: "1.1rem",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    gap: "0.25rem",
  },
  description: {
    marginTop: "1.5rem",
    padding: "1rem",
    fontSize: "16px",
    color: "#2c1810",
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderRadius: "10px",
    lineHeight: "1.7",
    fontFamily: "'Cormorant Garamond', serif",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    backdropFilter: "blur(8px)",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    position: "relative",
  },
  descriptionContent: {
    overflow: "hidden",
    transition: "max-height 0.3s ease-in-out",
  },
  descriptionCollapsed: {
    maxHeight: "6.8em", // 4 lignes avec line-height 1.7
    overflow: "hidden",
  },
  descriptionExpanded: {
    maxHeight: "none",
  },
  showMoreButton: {
    background: "rgba(212, 175, 55, 0.1)",
    border: "1px solid rgba(212, 175, 55, 0.3)",
    borderRadius: "15px",
    padding: "8px 16px",
    color: "#2c1810",
    cursor: "pointer",
    fontSize: "14px",
    fontFamily: "'Cormorant Garamond', serif",
    transition: "all 0.3s ease",
    marginTop: "10px",
    textAlign: "center",
    gridColumn: "1 / -1",
  },
  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "5px",
    color: "#2c1810",
    fontSize: "16px",
    fontFamily: "'Cormorant Garamond', serif",
  },
  colorButtons: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "15px",
  },
  colorButton: {
    padding: "8px 14px",
    borderRadius: "20px",
    border: "1px solid rgba(212, 175, 55, 0.3)",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    color: "#2c1810",
    cursor: "pointer",
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: "14px",
    backdropFilter: "blur(10px)",
    transition: "all 0.3s ease",
  },
  colorButtonSelected: {
    border: "2px solid #d4af37",
    backgroundColor: "#d4af37",
    color: "white",
    boxShadow: "0 4px 12px rgba(212, 175, 55, 0.3)",
  },
  sizeButtons: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginBottom: "15px",
  },
  sizeButton: {
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    border: "1px solid rgba(212, 175, 55, 0.3)",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    color: "#2c1810",
    cursor: "pointer",
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: "14px",
    backdropFilter: "blur(10px)",
    transition: "all 0.3s ease",
  },
  sizeButtonSelected: {
    border: "2px solid #d4af37",
    backgroundColor: "#d4af37",
    color: "white",
    boxShadow: "0 4px 12px rgba(212, 175, 55, 0.3)",
  },
  sizeButtonDisabled: {
    opacity: 0.5,
    cursor: "not-allowed",
  },
  addToCartButton: {
    marginTop: "15px",
    width: "100%",
    padding: "16px 0",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
    color: "#2c1810",
    fontWeight: "600",
    fontSize: "1.2rem",
    border: "2px solid #4ade80",
    borderRadius: "15px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontFamily: "'Cormorant Garamond', serif",
    letterSpacing: "0.5px",
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
  },
  addToCartButtonHover: {
    transform: "translateY(-2px)",
    boxShadow: "0 8px 25px rgba(74, 222, 128, 0.3)",
    borderColor: "#22c55e",
  },
  buyNowButton: {
    marginTop: "12px",
    width: "100%",
    padding: "16px 0",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
    color: "#2c1810",
    fontWeight: "600",
    fontSize: "1.2rem",
    border: "2px solid #4ade80",
    borderRadius: "15px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontFamily: "'Cormorant Garamond', serif",
    letterSpacing: "0.5px",
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
  },
  buyNowButtonHover: {
    transform: "translateY(-2px)",
    boxShadow: "0 8px 25px rgba(74, 222, 128, 0.3)",
    borderColor: "#22c55e",
  },
  shippingSection: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: "2rem",
    gap: "1rem",
  },
  shippingCard: {
    flex: 1,
    minWidth: "150px",
    textAlign: "center",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    padding: "1rem",
    borderRadius: "12px",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(10px)",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  },
  shippingIcon: {
    marginBottom: "10px",
    color: "#d4af37",
    fontSize: "22px",
  },
  shippingText: {
    fontSize: "14px",
    color: "#5a4a3a",
    lineHeight: "1.4",
    fontFamily: "'Cormorant Garamond', serif",
  },
  avisSection: {
    marginTop: "3rem",
    padding: "2rem",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(15px)",
    borderRadius: "15px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.08)",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
  },
  avisSectionBefore: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)",
    borderRadius: "15px",
    zIndex: -1,
  },
  avisTitle: {
    fontSize: "20px",
    marginBottom: "1rem",
    color: "#2c1810",
    fontFamily: "'Cormorant Garamond', serif",
    fontWeight: "bold",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "50vh",
    padding: "2rem",
    fontFamily: "'Cormorant Garamond', serif",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(20px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
  },
  loadingText: {
    color: "#2c1810",
    fontSize: "1rem",
    fontWeight: "500",
    margin: "0",
    fontFamily: "'Cormorant Garamond', serif",
  },
  errorContainer: {
    padding: "2rem",
    color: "red",
    textAlign: "center",
    fontSize: "1rem",
    fontFamily: "'Cormorant Garamond', serif",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(20px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
  },
  notFoundContainer: {
    padding: "2rem",
    textAlign: "center",
    fontSize: "1rem",
    color: "#2c1810",
    fontFamily: "'Cormorant Garamond', serif",
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    backdropFilter: "blur(20px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.2)",
  },
};

const buildImageUrl = (filename) => {
  if (!filename || typeof filename !== "string") return "";

  // URL complète détectée, on la retourne brute
  if (/^https?:\/\//i.test(filename)) {
    return filename;
  }

  // Sinon on construit URL locale
  let cleanFilename = filename.startsWith("/") ? filename.slice(1) : filename;

  if (cleanFilename.startsWith("public/")) {
    cleanFilename = cleanFilename.slice("public/".length);
  }

  if (!cleanFilename.startsWith("uploads/")) {
    cleanFilename = `uploads/${cleanFilename}`;
  }

  return `${apiUrl}/${cleanFilename}`.replace(/([^:]\/)\/+/g, "$1");
};

export default function Product() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedTaille, setSelectedTaille] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isFavorite, setIsFavorite] = useState(false);
  const [favLoading, setFavLoading] = useState(false);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [orderForm, setOrderForm] = useState({ fullName: "", phone: "", city: "", address: "" });
  const [orderSubmitting, setOrderSubmitting] = useState(false);
  const [orderQty, setOrderQty] = useState(1);
  const [promoCode, setPromoCode] = useState("");
  const [promoData, setPromoData] = useState(null);
  const [promoMessage, setPromoMessage] = useState("");
  const [phoneTouched, setPhoneTouched] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await axios.get(`${apiUrl}/api/shop/products/${id}`, {
          withCredentials: true,
        });
        setProduct(res.data.product);
        setSelectedColor(res.data.product.variantes[0]?.couleur || null);
        setSelectedImageIndex(0);
      } catch (err) {
        setError("Erreur lors du chargement du produit.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    const fetchFavorites = async () => {
      try {
        const res = await axios.get(`${apiUrl}/api/favorites`, {
          withCredentials: true,
        });
        const favorites = res.data.favorites || [];
        // 🔍 VÉRIFIER QUE LE PRODUIT EXISTE AVANT D'ACCÉDER À _id
        const found = favorites.some((f) => f.product && f.product._id === id);
        setIsFavorite(found);
      } catch (err) {
        console.error("Erreur lors du fetch des favoris:", err);
      }
    };

    fetchProduct();
    fetchFavorites();
  }, [id]);

  const toggleFavorite = async () => {
    if (favLoading) return;
    setFavLoading(true);

    try {
      if (isFavorite) {
        await axios.delete(`${apiUrl}/api/favorites/${id}`, {
          withCredentials: true,
        });
        setIsFavorite(false);
        toast.success("Retiré des favoris !", {
          onClick: () => navigate("/favoris"),
          style: { cursor: "pointer" },
        });
      } else {
        await axios.post(
          `${apiUrl}/api/favorites/${id}`,
          {},
          { withCredentials: true }
        );
        setIsFavorite(true);
        toast.success("Ajouté aux favoris !", {
          onClick: () => navigate("/favoris"),
          style: { cursor: "pointer" },
        });
      }
    } catch (err) {
      console.error("Erreur lors du toggle favoris:", err);
      toast.error("Veuillez vous connecter pour ajouter aux favoris.", {
        onClick: () => navigate("/login"),
        style: { cursor: "pointer" },
      });
    } finally {
      setFavLoading(false);
    }
  };

  const currentVariante = product?.variantes.find(
    (v) => v.couleur === selectedColor
  );
  const images = currentVariante?.images || [];
  const hasPromo =
    product?.price?.promoPrice != null &&
    Number(product.price.promoPrice) < Number(product.price.originalPrice);
  const originalUnitPrice = Number(
    product?.price?.originalPrice ?? product?.price ?? 0
  );
  const baseUnitPrice = hasPromo
    ? Number(product?.price?.promoPrice || 0)
    : originalUnitPrice;
  const finalUnitPrice = promoData?.pourcentage
    ? Math.max(
        0,
        originalUnitPrice - (promoData.pourcentage / 100) * originalUnitPrice
      )
    : baseUnitPrice;
  const selectedStock = currentVariante?.stock?.find((s) => s.taille === selectedTaille)?.quantity ?? null;

  const formatPrice = (price) => `${Number(price || 0).toFixed(2)} dh`;

  const normalizeMoroccanPhone = (input) => {
    if (!input) return "";
    let raw = String(input).trim();
    // Garder les chiffres uniquement
    raw = raw.replace(/\D+/g, "");
    // Convertir 212XXXXXXXXX en 0XXXXXXXXX
    if (raw.startsWith("00212")) {
      raw = `0${raw.slice(5)}`;
    } else if (raw.startsWith("212")) {
      raw = `0${raw.slice(3)}`;
    }
    // Si l'utilisateur tape 9 chiffres en commençant par [5-7], préfixer 0
    if (/^[5-7]\d{8}$/.test(raw)) {
      raw = `0${raw}`;
    }
    return raw;
  };

  const isValidMoroccanPhone = (input) => {
    const digits = normalizeMoroccanPhone(input);
    return /^0[5-7]\d{8}$/.test(digits);
  };

  const formatMoroccanPhoneVisual = (input) => {
    const digits = normalizeMoroccanPhone(input).slice(0, 10);
    const g1 = digits.slice(0, 2);
    const g2 = digits.slice(2, 4);
    const g3 = digits.slice(4, 6);
    const g4 = digits.slice(6, 8);
    const g5 = digits.slice(8, 10);
    return [g1, g2, g3, g4, g5].filter(Boolean).join(" ");
  };

  const handleOpenOrderModal = () => {
    if (!selectedColor || !selectedTaille) {
      toast.error("Veuillez choisir une couleur et une taille avant de commander.");
      return;
    }
    setOrderQty(1);
    setIsOrderModalOpen(true);
  };

  const handleCloseOrderModal = () => {
    if (orderSubmitting) return;
    setIsOrderModalOpen(false);
    // Réinitialiser le code promo à la fermeture
    setPromoCode("");
    setPromoData(null);
    setPromoMessage("");
  };

  const handleOrderChange = (e) => {
    const { name, value } = e.target;
    setOrderForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleOrderSubmit = async (e) => {
    e.preventDefault();
    if (!orderForm.fullName.trim() || !orderForm.phone.trim() || !orderForm.city.trim() || !orderForm.address.trim()) {
      toast.error("Veuillez remplir tous les champs.");
      return;
    }
    if (!isValidMoroccanPhone(orderForm.phone)) {
      setPhoneTouched(true);
      toast.error("Veuillez saisir un numéro de téléphone marocain valide (ex: 06XXXXXXXX).");
      return;
    }
    try {
      setOrderSubmitting(true);
      const normalizedPhone = normalizeMoroccanPhone(orderForm.phone);
      await axios.post(`${apiUrl}/api/orders/quick`, {
        productId: product._id,
        name: product.name,
        couleur: selectedColor,
        taille: selectedTaille,
        // Utiliser le prix unitaire final tenant compte du code promo
        price: Number(finalUnitPrice.toFixed(2)),
        quantity: orderQty,
        fullName: orderForm.fullName,
        phone: normalizedPhone,
        city: orderForm.city,
        address: orderForm.address,
        email: null, // si vous avez l'email du client connecté, vous pouvez le passer ici
        // Informations promo (le backend quick ignore si non gérées, mais utile pour tracing)
        promo: promoData?.pourcentage
          ? { code: promoCode, pourcentage: promoData.pourcentage }
          : null,
      });
      toast.success("Commande envoyée. Un agent vous appellera pour confirmer.");
      setIsOrderModalOpen(false);
      setOrderForm({ fullName: "", phone: "", city: "", address: "" });
      setPromoCode("");
      setPromoData(null);
      setPromoMessage("");
      // Redirection vers la page d'accueil avec un état pour afficher un modal de succès
      navigate("/", { state: { orderSuccess: true } });
    } catch (err) {
      toast.error("Une erreur est survenue. Merci de réessayer.");
    } finally {
      setOrderSubmitting(false);
    }
  };

  const handleApplyPromo = async () => {
    if (!promoCode.trim()) {
      setPromoMessage("Veuillez saisir un code promo.");
      return;
    }
    setPromoMessage("Vérification...");
    try {
      const res = await api.post(`/api/promos/validate`, { code: promoCode.trim() });
      setPromoData(res.data);
      setPromoMessage(
        `Code promo "${promoCode.toUpperCase()}" appliqué: ${res.data.pourcentage}% de réduction.`
      );
    } catch (err) {
      setPromoData(null);
      setPromoMessage(err.response?.data?.error || "Code invalide.");
    }
  };

  const handleCancelPromo = () => {
    setPromoData(null);
    setPromoCode("");
    setPromoMessage("Code promo annulé.");
  };

  const renderLargePreview = () => {
    const filename = images[selectedImageIndex];
    const url = buildImageUrl(filename);
    if (!filename) return null;

    if (filename.match(/\.(jpg|jpeg|png|gif|webp)$/i)) {
      return (
        <img
          src={url}
          alt={`Produit ${product.name}`}
          style={styles.mainImage}
        />
      );
    }

    if (filename.match(/\.(glb|gltf|obj)$/i)) {
      return <ThreeModelViewer url={url} width="100%" height={400} />;
    }

    return (
      <p
        style={{
          fontFamily: "'Cormorant Garamond', serif",
          fontSize: "1rem",
          color: "#222",
        }}
      >
        Format non supporté
      </p>
    );
  };

  if (loading)
    return (
      <div style={styles.loadingContainer}>
        <div
          style={{
            position: "relative",
            width: "60px",
            height: "60px",
            marginBottom: "1rem",
          }}
        >
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              border: "3px solid transparent",
              borderTop: "3px solid #4299e1",
              borderRadius: "50%",
              animation: "spin 1.5s linear infinite",
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              border: "3px solid transparent",
              borderRight: "3px solid #38b2ac",
              borderRadius: "50%",
              animation: "spin 1.5s linear infinite",
              animationDelay: "0.5s",
            }}
          ></div>
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              border: "3px solid transparent",
              borderBottom: "3px solid #ed8936",
              borderRadius: "50%",
              animation: "spin 1.5s linear infinite",
              animationDelay: "1s",
            }}
          ></div>
        </div>
        <p style={styles.loadingText}>Chargement en cours...</p>
      </div>
    );

  if (error) return <div style={styles.errorContainer}>{error}</div>;
  if (!product)
    return <div style={styles.notFoundContainer}>Produit introuvable</div>;


  return (
    <>
      <div style={{ height: window.innerWidth <= 768 ? "5vh" : "10vh" }}></div>

      <div style={styles.container}>
        <div style={styles.containerBefore}></div>
        <div style={styles.productGrid}>
          {/* Images produit */}
          <div style={styles.imageSection}>
            <div style={{ width: "100%", marginBottom: "1rem" }}>
              {renderLargePreview()}
            </div>
            <div style={styles.thumbnailContainer}>
              {images.length > 0 ? (
                images.map((filename, idx) => {
                  if (!filename || typeof filename !== "string") return null;
                  const url = buildImageUrl(filename);
                  const isSelected = idx === selectedImageIndex;

                  if (filename.match(/\.(jpg|jpeg|png|gif|webp)$/i)) {
                    return (
                      <img
                        key={idx}
                        src={url}
                        alt={`Miniature ${idx + 1}`}
                        onClick={() => setSelectedImageIndex(idx)}
                        style={{
                          ...styles.thumbnail,
                          ...(isSelected ? styles.thumbnailSelected : {}),
                        }}
                      />
                    );
                  }

                  if (filename.match(/\.(glb|gltf|obj)$/i)) {
                    return (
                      <div
                        key={idx}
                        onClick={() => setSelectedImageIndex(idx)}
                        style={{
                          ...styles.thumbnail,
                          ...(isSelected ? styles.thumbnailSelected : {}),
                          overflow: "hidden",
                        }}
                      >
                        <ThreeModelViewer
                          url={url}
                          width="100%"
                          height="100%"
                        />
                      </div>
                    );
                  }

                  return (
                    <p
                      key={idx}
                      style={{
                        fontFamily: "'Cormorant Garamond', serif",
                        fontSize: "1rem",
                        color: "#2c1810",
                      }}
                    >
                      Fichier non supporté
                    </p>
                  );
                })
              ) : (
                <p
                  style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: "1rem",
                    color: "#2c1810",
                  }}
                >
                  Aucune image
                </p>
              )}
            </div>
          </div>

          {/* Détails produit */}
          <div style={{
            ...styles.detailsSection,
            minWidth: isMobile ? "100%" : "350px"
          }}>
            <div style={styles.detailsSectionBefore}></div>
            <div style={styles.productHeader}>
              <h1 style={styles.productTitle}>{product.name}</h1>
              <button
                onClick={toggleFavorite}
                disabled={favLoading}
                style={styles.favoriteButton}
                aria-label={
                  isFavorite ? "Retirer des favoris" : "Ajouter aux favoris"
                }
              >
                {isFavorite ? <FaHeart /> : <FaRegHeart />}
              </button>
            </div>

            {/* Affichage des prix modernisé */}
            <div style={styles.priceContainer}>
              {hasPromo ? (
                <>
                  <div style={styles.originalPrice}>
                    {product.price.originalPrice} MAD
                  </div>
                  <div style={styles.promoPriceContainer}>
                    <span style={styles.promoPrice}>
                      {product.price.promoPrice.toFixed(2)} MAD
                    </span>
                    <span style={styles.promoBadge}>
                      <FaTag style={{ fontSize: "0.65rem" }} />
                      {product.promo}%
                    </span>
                  </div>
                </>
              ) : (
                <div style={styles.normalPrice}>
                  {product.price.originalPrice} MAD
                </div>
              )}
            </div>

            <div style={styles.description}>
              <div
                style={{
                  ...styles.descriptionContent,
                  ...(showFullDescription
                    ? styles.descriptionExpanded
                    : styles.descriptionCollapsed),
                }}
              >
                <ReactMarkdown
                  components={{
                    h1: ({ node, ...props }) => (
                      <h1
                        style={{
                          fontSize: "24px",
                          fontWeight: "bold",
                          marginBottom: "1rem",
                        }}
                        {...props}
                      />
                    ),
                    h2: ({ node, ...props }) => (
                      <h2
                        style={{
                          fontSize: "20px",
                          fontWeight: "bold",
                          marginBottom: "0.75rem",
                        }}
                        {...props}
                      />
                    ),
                    p: ({ node, ...props }) => (
                      <p
                        style={{ marginBottom: "0.8rem", color: "#3e2c1c" }}
                        {...props}
                      />
                    ),
                    ul: ({ node, ...props }) => (
                      <ul
                        style={{
                          paddingLeft: "1.5rem",
                          marginBottom: "1rem",
                          listStyleType: "disc",
                          color: "#3e2c1c",
                        }}
                        {...props}
                      />
                    ),
                    ol: ({ node, ...props }) => (
                      <ol
                        style={{
                          paddingLeft: "1.5rem",
                          marginBottom: "1rem",
                          listStyleType: "decimal",
                          color: "#3e2c1c",
                        }}
                        {...props}
                      />
                    ),
                    li: ({ node, ...props }) => (
                      <li style={{ marginBottom: "0.4rem" }} {...props} />
                    ),
                  }}
                >
                  {product.description}
                </ReactMarkdown>
              </div>

              <button
                style={styles.showMoreButton}
                onClick={() => setShowFullDescription(!showFullDescription)}
                onMouseEnter={(e) => {
                  e.target.style.background = "rgba(212, 175, 55, 0.2)";
                  e.target.style.borderColor = "#d4af37";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "rgba(212, 175, 55, 0.1)";
                  e.target.style.borderColor = "rgba(212, 175, 55, 0.3)";
                }}
              >
                {showFullDescription ? "Voir moins" : "Voir plus"}
              </button>
            </div>

            {/* Couleurs */}
            <div>
              <div style={styles.sectionTitle}>Couleur:</div>
              <div style={styles.colorButtons}>
                {product.variantes.map((v, idx) => (
                  <motion.button
                    key={idx}
                    whileHover={{ scale: 1.05 }}
                    onClick={() => {
                      setSelectedColor(v.couleur);
                      setSelectedTaille(null);
                      setSelectedImageIndex(0);
                    }}
                    style={{
                      ...styles.colorButton,
                      ...(selectedColor === v.couleur
                        ? styles.colorButtonSelected
                        : {}),
                    }}
                  >
                    {v.couleur}
                  </motion.button>
                ))}
              </div>
            </div>

            {/* Tailles */}
            {currentVariante?.stock?.length > 0 && (
              <div>
                <div style={styles.sectionTitle}>Taille:</div>
                <div style={styles.sizeButtons}>
                  {currentVariante.stock.map((s, i) => (
                    <motion.button
                      key={i}
                      whileHover={{ scale: 1.05 }}
                      disabled={s.quantity === 0}
                      onClick={() => setSelectedTaille(s.taille)}
                      style={{
                        ...styles.sizeButton,
                        ...(selectedTaille === s.taille
                          ? styles.sizeButtonSelected
                          : {}),
                        ...(s.quantity === 0 ? styles.sizeButtonDisabled : {}),
                      }}
                    >
                      {s.taille}
                    </motion.button>
                  ))}
                </div>
              </div>
            )}

            {/* Ajouter au panier */}
            <div>
              <motion.button
                whileHover={{ scale: 1.01 }}
                onClick={handleOpenOrderModal}
                style={{
                  ...styles.buyNowButton,
                  marginTop: 12,
                  backgroundColor: "#d4af37",
                  color: "white",
                  border: "none",
                }}
              >
                Commander maintenant
              </motion.button>
              <motion.div whileHover={{ scale: 1.01 }}>
                <AddToCart
                  product={product}
                  selectedColor={selectedColor}
                  selectedTaille={selectedTaille}
                  setSelectedColor={setSelectedColor}
                  setSelectedTaille={setSelectedTaille}
                />
              </motion.div>
            </div>

            {/* Livraison et paiement */}
            <div style={styles.shippingSection}>
              <div style={styles.shippingCard}>
                <FaTruck style={styles.shippingIcon} />
                <p style={styles.shippingText}>
                  Livraison gratuite au Maroc entre 3 et 15 jours.
                </p>
              </div>
              <div style={styles.shippingCard}>
                <FaUndo style={styles.shippingIcon} />
                <p style={styles.shippingText}>
                  Pour l'étranger, frais de retour à votre charge.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Intégration des avis */}
        <div style={styles.avisSection}>
          <Avis productId={id} />
        </div>
      </div>

      <Footer />

      {isOrderModalOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={handleCloseOrderModal}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "95%",
              maxWidth: 520,
              background: "#fff",
              borderRadius: 12,
              padding: 20,
              boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
              fontFamily: "'Cormorant Garamond', serif",
              color: "#2c1810",
              maxHeight: "85vh",
              overflowY: "auto",
              WebkitOverflowScrolling: "touch",
            }}
          >
            <h3 style={{ marginTop: 0, marginBottom: 10 }}>Essayez d’abord, Payez après!</h3>
            <div style={{ fontSize: 14, marginBottom: 12 }}>
              <div><strong>Nom produit</strong>: {product.name}</div>
              <div><strong>Couleur</strong>: {selectedColor}</div>
              <div><strong>Taille</strong>: {selectedTaille}</div>
            </div>
            <div
              style={{
                border: "1px solid #eee",
                borderRadius: 8,
                padding: 12,
                marginBottom: 16,
                background: "#fafafa",
                fontSize: 14,
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10, alignItems: "center" }}>
                <span>Quantité</span>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <button
                    type="button"
                    onClick={() => setOrderQty((q) => Math.max(1, q - 1))}
                    disabled={!selectedTaille || orderQty <= 1}
                    style={{ padding: "4px 10px", borderRadius: 6, border: "1px solid #ddd", background: "#fff", cursor: "pointer" }}
                  >
                    −
                  </button>
                  <input
                    type="number"
                    min={1}
                    max={selectedStock ?? undefined}
                    value={orderQty}
                    onChange={(e) => {
                      const val = Number(e.target.value) || 1;
                      const capped = selectedStock != null ? Math.min(Math.max(1, val), selectedStock) : Math.max(1, val);
                      setOrderQty(capped);
                    }}
                    disabled={!selectedTaille}
                    style={{ width: 70, textAlign: "center", padding: 6, border: "1px solid #ddd", borderRadius: 6 }}
                  />
                  <button
                    type="button"
                    onClick={() => setOrderQty((q) => (selectedStock != null ? Math.min(q + 1, selectedStock) : q + 1))}
                    disabled={!selectedTaille || (selectedStock != null && orderQty >= selectedStock)}
                    style={{ padding: "4px 10px", borderRadius: 6, border: "1px solid #ddd", background: "#fff", cursor: "pointer" }}
                  >
                    +
                  </button>
                </div>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <span>Sous-total</span>
                <span>{formatPrice(originalUnitPrice * orderQty)}</span>
              </div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                <span>Livraison</span>
                <span>Gratuit</span>
              </div>
              {promoData?.pourcentage && (
                <div style={{ display: "flex", justifyContent: "space-between", margin: "6px 0", color: "#16a34a" }}>
                  <span>Réduction ({promoData.pourcentage}%)</span>
                  <span>
                    -
                    {formatPrice(
                      (originalUnitPrice * orderQty * promoData.pourcentage) / 100
                    )}
                  </span>
                </div>
              )}
              <div style={{ height: 1, background: "#e5e7eb", margin: "8px 0" }} />
              <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700 }}>
                <span>Total</span>
                <span>{formatPrice(finalUnitPrice * orderQty)}</span>
              </div>
            </div>

            {/* Code promo */}
            <div style={{
              border: "1px solid #eee",
              borderRadius: 8,
              padding: 12,
              marginBottom: 16,
              background: "#fff",
              fontSize: 14
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, fontWeight: 600, color: "#2c1810" }}>
                <FaGift /> Code promo
              </div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <input
                  type="text"
                  value={promoCode}
                  onChange={(e) => setPromoCode(e.target.value)}
                  placeholder="Ex: SUMMER25"
                  disabled={!!promoData}
                  style={{ flex: 1, minWidth: 140, padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
                />
                {!promoData ? (
                  <button type="button" onClick={handleApplyPromo} style={{ padding: "10px 14px", borderRadius: 8, border: "1px solid #d4af37", background: "rgba(212,175,55,0.15)", cursor: "pointer" }}>
                    Appliquer
                  </button>
                ) : (
                  <button type="button" onClick={handleCancelPromo} style={{ padding: "10px 14px", borderRadius: 8, border: "1px solid #ddd", background: "#fff", color: "#d32f2f", cursor: "pointer" }}>
                    Annuler
                  </button>
                )}
              </div>
              {promoMessage && (
                <div style={{ marginTop: 8, fontWeight: 600, color: promoData ? "#16a34a" : "#d32f2f" }}>
                  {promoMessage}
                </div>
              )}
            </div>

            <form onSubmit={handleOrderSubmit}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 10 }}>
                <div>
                  <label>Nom complet / الاسم الكامل</label>
                  <input
                    name="fullName"
                    value={orderForm.fullName}
                    onChange={handleOrderChange}
                    style={{ width: "100%", padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
                  />
                </div>
                <div>
                  <label>Téléphone / رقم الهاتف</label>
                  <input
                    name="phone"
                    value={orderForm.phone}
                    onChange={(e) => {
                      const raw = e.target.value;
                      const formatted = formatMoroccanPhoneVisual(raw);
                      setOrderForm((prev) => ({ ...prev, phone: formatted }));
                    }}
                    onBlur={() => {
                      setPhoneTouched(true);
                      setOrderForm((prev) => ({
                        ...prev,
                        phone: formatMoroccanPhoneVisual(prev.phone),
                      }));
                    }}
                    inputMode="tel"
                    placeholder="Ex: 06 12 34 56 78"
                    maxLength={14}
                    pattern={"^0[5-7](?:\\s?\\d{2}){4}$"}
                    title={"Numéro marocain attendu"}
                    style={{
                      width: "100%",
                      padding: 10,
                      border: phoneTouched && orderForm.phone && !isValidMoroccanPhone(orderForm.phone) ? "1px solid #d32f2f" : "1px solid #ddd",
                      borderRadius: 8,
                    }}
                  />
                  {phoneTouched && orderForm.phone && !isValidMoroccanPhone(orderForm.phone) && (
                    <div style={{ marginTop: 6, color: "#d32f2f", fontSize: 12 }}>
                      Numéro marocain invalide. Exemple attendu: 06 12 34 56 78
                    </div>
                  )}
                </div>
                <div>
                  <label>Ville / المدينة</label>
                  <input
                    name="city"
                    value={orderForm.city}
                    onChange={handleOrderChange}
                    style={{ width: "100%", padding: 10, border: "1px solid #ddd", borderRadius: 8 }}
                  />
                </div>
                <div>
                  <label>Adresse / العنوان</label>
                  <textarea
                    name="address"
                    value={orderForm.address}
                    onChange={handleOrderChange}
                    rows={3}
                    style={{ width: "100%", padding: 10, border: "1px solid #ddd", borderRadius: 8, resize: "vertical" }}
                  />
                </div>
              </div>

              <p style={{ fontSize: 13, color: "#4b5563", marginTop: 10 }}>
                Un agent vous appellera pour confirmer votre commande et la date de livraison.
              </p>

              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 12 }}>
                <button
                  type="button"
                  onClick={handleCloseOrderModal}
                  disabled={orderSubmitting}
                  style={{
                    padding: "10px 14px",
                    background: "#eee",
                    border: "none",
                    borderRadius: 8,
                    cursor: "pointer",
                  }}
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={orderSubmitting}
                  style={{
                    padding: "10px 14px",
                    background: "#22c55e",
                    color: "white",
                    border: "none",
                    borderRadius: 8,
                    cursor: "pointer",
                    fontWeight: 700,
                  }}
                >
                  {orderSubmitting ? "Envoi..." : "Commandez maintenant"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
